export default {
    path: '/modules/clients',
    component: () => import('@/modules/accounts/pages/index.vue'),
    children: [
        {
            // path: 'view/:client_id?',
            path:'view',
            component: () => import('@/modules/clients/pages/edit.vue'),
            meta: {
                pageTitle: '查看客户',
                parent: '/modules/clients/list',
            }
        },
        {
            path: 'list',
            component: () => import('@/modules/clients/pages/list.vue'),
            meta: {
                pageTitle: '客户列表',
            }
        },

    ]
};
